import { call, put, all } from 'redux-saga/effects';

import { getRegFilingTypesList } from '@api/filingTypes';
import { getMappingList } from '@api/mapping';
import { intl } from '@helpers/intl';
import { conversionToolMappingsList } from '@models/ConversionTool';
import {
  conversionToolMappingsFetchFailure,
  conversionToolMappingsFetchSuccess,
} from '@store/conversionTool/conversionToolMappings/conversionToolMappings.actions';

export const conversionToolMappingsFetchSaga = function* ({ payload }) {
  try {
    const { entityJurisdictionId } = payload;
    const [filingResponse, mappingListResponse] = yield all([
      call(getRegFilingTypesList, entityJurisdictionId),
      call(getMappingList, entityJurisdictionId),
    ]);

    const list = conversionToolMappingsList(mappingListResponse.results, filingResponse.results);
    yield put(conversionToolMappingsFetchSuccess(list));
  } catch (errors) {
    const { nonFieldErrors } = errors?.data || {};

    const errorMessage =
      nonFieldErrors ||
      intl.formatMessage({
        defaultMessage: 'The mappings could not be retrieved. Please try again.',
        id: 'global.notification.api-error-conversion-tool-settings',
      });

    yield put(conversionToolMappingsFetchFailure({ errorMessage }));
  }
};
